import { render, staticRenderFns } from "./packageDetails.vue?vue&type=template&id=58a641b6&scoped=true&"
import script from "./packageDetails.vue?vue&type=script&lang=js&"
export * from "./packageDetails.vue?vue&type=script&lang=js&"
import style0 from "./packageDetails.vue?vue&type=style&index=0&id=58a641b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a641b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\胶己人\\jjr_store_reservation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a641b6')) {
      api.createRecord('58a641b6', component.options)
    } else {
      api.reload('58a641b6', component.options)
    }
    module.hot.accept("./packageDetails.vue?vue&type=template&id=58a641b6&scoped=true&", function () {
      api.rerender('58a641b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packageDetails.vue"
export default component.exports